import styled from "styled-components";

export const UserBankrollBox = styled.div`
    font-size: 1.3rem;
    color: ${props => props.theme.colors.moneyColor};
    padding: 0px 8px;
    white-space: nowrap;
`